import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck, Flame, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferBlock() {
  return <section id="offer" className="bg-forest py-8 px-4 md:px-8 relative overflow-hidden" data-id="element-115">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-116">
        <div className="absolute -top-16 -left-16 w-64 h-64 rounded-full bg-white blur-3xl" data-id="element-117"></div>
      </div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-118">
        <FadeIn data-id="element-119">
          {/* Urgency Banner */}
          <motion.div animate={{
          opacity: [0.85, 1, 0.85]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="bg-red-600 text-white text-center py-2.5 px-4 rounded-t-2xl flex items-center justify-center gap-2" data-id="element-120">
            <Flame className="w-4 h-4 shrink-0" data-id="element-121" />
            <span className="font-bold text-sm tracking-wide uppercase" data-id="element-122">
              Limited Time Offer — Price Goes Up Soon
            </span>
            <Flame className="w-4 h-4 shrink-0" data-id="element-123" />
          </motion.div>

          <div className="bg-cream rounded-b-2xl p-5 md:p-8 shadow-2xl text-center border-2 border-t-0 border-gold/30" data-id="element-124">
            <h2 className="text-2xl md:text-3xl font-bold text-forest mb-2" data-id="element-125">
              Reclaim Your Mornings
            </h2>
            <p className="text-sm md:text-base text-charcoal mb-4 max-w-lg mx-auto" data-id="element-126">
              Stop the "rust" from settling into your joints. Get the complete
              10-Minute Anti-Inflammatory Kitchen protocol today.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-4" data-id="element-127">
              <div className="w-36 md:w-44 shrink-0" data-id="element-128">
                <img src="https://cdn.magicpatterns.com/uploads/abWjdQcvy5Qp2bFZtuoR2f/MockupEbook10MinuteNew.png" alt="Ebook Cover" className="w-full h-auto rounded-lg shadow-lg" data-id="element-129" />
              </div>

              <div className="text-center md:text-left w-full md:w-auto" data-id="element-130">
                <div className="mb-1" data-id="element-131">
                  <span className="text-gray-500 uppercase tracking-wider font-semibold text-xs" data-id="element-132">
                    One-Time Investment
                  </span>
                </div>

                {/* Pricing Block */}
                <div className="flex items-baseline justify-center md:justify-start gap-3 mb-1" data-id="element-133">
                  <span className="text-xl text-gray-400 line-through font-medium" data-id="element-134">
                    $19.99
                  </span>
                  <span className="text-4xl font-bold text-forest" data-id="element-135">$6.39</span>
                </div>

                {/* Savings Badge */}
                <div className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 font-bold text-xs uppercase tracking-wide px-3 py-1 rounded-full mb-3" data-id="element-136">
                  <span data-id="element-137">🎉</span>
                  <span data-id="element-138">You Save $13.60 (68% Off)</span>
                </div>

                {/* Urgency Subtext */}
                <div className="flex items-center justify-center md:justify-start gap-1.5 text-red-600 mb-4" data-id="element-139">
                  <Clock className="w-3.5 h-3.5" data-id="element-140" />
                  <span className="text-xs font-semibold" data-id="element-141">
                    Only available at this price for a limited time
                  </span>
                </div>

                <Button href="https://www.vitaleaseliving.com/cart/53126374687004:1" className="w-full md:w-auto px-8 py-3 text-base shadow-lg hover:scale-105 transform transition-all" data-id="element-142">
                  GET THE 10-MINUTE PROTOCOL NOW
                </Button>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-gray-600 bg-white/50 py-2 px-4 rounded-full inline-flex mx-auto text-xs" data-id="element-143">
              <ShieldCheck className="w-4 h-4 text-forest" data-id="element-144" />
              <span className="font-medium" data-id="element-145">
                Safe & Secure Digital Delivery. Access immediately after
                purchase.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}